<template>
  <el-dialog
    top="50px"
    width="900px"
    :title="isCreate ? 'Cài đặt quy trình' : 'Sửa cài đặt quy trình'"
    :visible="visible"
    :show-close="!callingAPI"
    @close="$emit('close')"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :show-message="true"
      size="small"
    >
      <el-row
        label-position="top"
        type="flex"
        align="start"
        class="flex-wrap"
        :gutter="12"
      >
        <el-col
:lg="24"
:span="24">
          <el-form-item
prop="contract_id"
label="Quy trình">
            <el-select
              v-model="form.contract_id"
              placeholder="Chọn quy trình"
              filterable
              :disabled="!isCreate"
              class="w-100"
            >
              <el-option
                v-for="contract in allContracts"
                :key="contract.id"
                :label="contract.name"
                :value="contract.id"
                :disabled="contracts.map((c) => c.contract_id).includes(contract.id)"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
v-if="currentContract"
:lg="24"
:span="24">
          <el-table
            header-row-class-name="table-header"
            :data="form.steps"
            size="small"
          >
            <el-table-column
              :prop="'step_id'"
              label="Bước thực hiện"
              align="left"
            >
              <template slot-scope="scope">
                {{ scope.row.step_id | getStepName(currentContractSteps) }}
              </template>
            </el-table-column>
            <el-table-column
              :prop="'show_fields'"
              label="Trường hiển thị"
              align="left"
            >
              <template slot-scope="scope">
                {{ scope.row.show_fields | getFieldsName(fields) }}
              </template>
            </el-table-column>
            <el-table-column
              :prop="'update_fields'"
              label="Trường cập nhật"
              align="left"
            >
              <template slot-scope="scope">
                {{ scope.row.update_fields | getFieldsName(fields) }}
              </template>
            </el-table-column>
            <el-table-column
              :prop="'log_fields'"
              label="Trường truy vết"
              align="left"
            >
              <template slot-scope="scope">
                {{ scope.row.log_fields.map((f) => f.name).join(', ') }}
              </template>
            </el-table-column>
            <el-table-column
              label="Thao tác"
              width="100"
              fixed="right"
              align="center"
            >
              <template slot-scope="scope">
                <Buttons
                  :item="scope.row"
                  :buttons="['edit']"
                  @edit="(v) => handleUpdate(v)"
                />
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-form>
    <span
slot="footer"
class="dialog-footer">
      <el-button
:disabled="callingAPI"
size="medium"
@click="$emit('close')">
        Đóng
      </el-button>
      <el-button
        type="primary"
        :loading="callingAPI"
        size="medium"
        @click="handleConfirm"
      >
        Lưu
      </el-button>
    </span>
    <ContractStepFormPopup
      v-if="!!selectedStep && stepVisible"
      :visible="stepVisible"
      :item="selectedStep"
      :fields="fields"
      :current-step="currentStep"
      :default-step="form.steps[0]"
      @close="() => stepVisible = false"
      @save="handleSaveStep"
    />
  </el-dialog>
</template>

<script>
import Buttons from "@/components/items/Buttons.vue";
import ContractStepFormPopup from "./ContractStepForm.vue";
import { notification } from "@/utils/common";

export default {
  name: "ContractFormPopup",
  components: {
    Buttons,
    ContractStepFormPopup
  },
  props: {
    item: Object,
    visible: Boolean,
    contracts: Array,
    fields: Array,
    allContracts: Array,
    allContractSteps: Array
  },
  data() {
    return {
      form: {
        contract_id: this.item ? this.item.contract_id : "",
        steps: this.item ? this.item.steps : [],
      },
      callingAPI: false,
      selectedStep: null,
      stepVisible: false
    };
  },
  computed: {
    rules() {
      return {
        contract_id: [
          {
            required: true,
            message: "Quy trình không được để trống",
            trigger: ["blur", "change"],
          },
        ],
      };
    },
    isCreate() {
      return !this.item || !this.item.contract_id;
    },
    currentContract() {
      return this.allContracts.find((c) => c.id === this.form.contract_id)
    },
    currentContractSteps() {
      return this.allContractSteps.filter((s) => s.contract_id === this.form.contract_id)
    },
    currentStep() {
      return this.currentContractSteps.find((s) => s.id === this.selectedStep?.step_id)
    },
  },
  watch: {
    currentContract: "handleChangeContract"
  },
  methods: {
    handleChangeContract() {
      if (this.isCreate) {
        this.form.steps = this.currentContractSteps.map((s) => ({
          step_id: s.id,
          show_fields: [],
          update_fields: [],
          log_fields: []
        }))
      }
    },
    handleUpdate(step) {
      this.selectedStep = step;
      this.stepVisible = true;
    },
    handleSaveStep(step) {
      this.form.steps = this.form.steps.map((s) => {
        if (s.step_id === step.step_id) {
          return step
        }
        return s
      })
    },
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let contracts = [];
          if (this.isCreate) {
            contracts = [this.form, ...this.contracts];
          } else {
            contracts = this.contracts.map((c) => {
              if (c.contract_id === this.item.contract_id) {
                return this.form;
              }
              return c;
            });
          }
          this.$emit("save", {
            payload: { contracts },
            success: () => {
              notification(
                this,
                "success",
                "",
                "Cài đặt quy trình thành công"
              );
              this.$emit("close");
            },
            error: () => {
              notification(
                this,
                "error",
                "",
                "Cài đặt quy trình thất bại"
              );
            },
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
